"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoize = void 0;
const errors_1 = require("./errors");
const EXPECTED_MAX_CACHE_ENTRIES_PER_FN = 10000;
const EXPECTED_MAX_CACHE_KEY_LENGTH_PER_FN = 10000;
function memoize({ functionToMemoize, ttl, cacheKeyBuilder = (...args) => JSON.stringify(args), }) {
    const cache = {};
    return (async (...args) => {
        const cacheKey = await cacheKeyBuilder(...args);
        (0, errors_1.assertWithLog)(cacheKey.length < EXPECTED_MAX_CACHE_KEY_LENGTH_PER_FN, `Assumed cache key will not be longer than ${EXPECTED_MAX_CACHE_KEY_LENGTH_PER_FN}. Suspicious key ${cacheKey}`);
        cleanStaleCacheEntries(cache, ttl);
        if (!cache[cacheKey] || Date.now() - cache[cacheKey].lastSet > ttl) {
            cache[cacheKey] = {
                lastSet: Date.now(),
                promise: functionToMemoize(...args).catch((err) => {
                    delete cache[cacheKey];
                    throw err;
                }),
            };
        }
        return await cache[cacheKey].promise;
    });
}
exports.memoize = memoize;
const cleanStaleCacheEntries = (cache, ttl) => {
    const now = Date.now();
    const cacheKeys = Object.keys(cache);
    (0, errors_1.assertWithLog)(cacheKeys.length < EXPECTED_MAX_CACHE_ENTRIES_PER_FN, `Assumed cache key space will not grow over ${EXPECTED_MAX_CACHE_ENTRIES_PER_FN} but is ${cacheKeys.length}`);
    if (cacheKeys.length > 1000) {
        for (const key of cacheKeys) {
            if (now - cache[key].lastSet > ttl) {
                delete cache[key];
            }
        }
    }
};
//# sourceMappingURL=memoize.js.map